import { render, staticRenderFns } from "./StepExample.vue?vue&type=template&id=2bb32afe&"
import script from "./StepExample.vue?vue&type=script&lang=js&"
export * from "./StepExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports